import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  LineAssociation,
  CustomerUser,
  AttachRequest,
  ApiResponse,
} from '../models/line-association.model';
import { environment } from '../../environments/environment';

/**
 * Servicio para gestionar asociaciones de líneas de usuario
 * Consume la API real de Virgin Mobile
 */
@Injectable({
  providedIn: 'root',
})
export class LineAssociationService {
  private http = inject(HttpClient);

  // URLs de la API desde environment
  private readonly API_BASE = environment.apiSecureUrl;
  private readonly API_PUBLIC_BASE = environment.apiUrl;
  private readonly CUSTOMER_ENDPOINT = `${this.API_BASE}/customer`;
  private readonly PROFILE_ENDPOINT = `${this.API_PUBLIC_BASE}/profile`;
  getLineAssociationByUser: any;

  constructor() {}

  /**
   * Obtiene el customer user con sus líneas asociadas
   * Endpoint: GET /customer/lines?userId={userId}
   */
  getCustomerUser(): Observable<ApiResponse<LineAssociation[]>> {
    !environment.production && console.log('[LineAssociation] Obteniendo líneas del usuario:');
    const url = this.API_BASE.replace('/api/v1', '/api/v2/customer/line/association/user');

    return this.http.get<ApiResponse<LineAssociation[]>>(`${url}`, {});
  }

  /**
   * Crea una nueva asociación de línea
   * Endpoint: PUT /customer/line/attach
   */
  createLineAssociation(request: AttachRequest): Observable<ApiResponse<LineAssociation>> {
    !environment.production && console.log('[LineAssociation] Creando asociación:', request);

    return this.http.put<ApiResponse<LineAssociation>>(
      `${this.CUSTOMER_ENDPOINT}/line/attach`,
      request
    );
  }

  /**
   * Actualiza una asociación de línea (principalmente el alias)
   * Endpoint: PUT /customer/line
   */
  updateLineAssociation(line: LineAssociation): Observable<ApiResponse<LineAssociation>> {
    !environment.production && console.log('[LineAssociation] Actualizando línea:', line);

    return this.http.put<ApiResponse<LineAssociation>>(
      `${this.CUSTOMER_ENDPOINT}/line/${line.id}`,
      line
    );
  }

  /**
   * Elimina una asociación de línea
   * Endpoint: DELETE /customer/detach
   */
  deleteByUserAndMsisdn(request: {
    msisdn: string;
    customerId: string;
  }): Observable<ApiResponse<void>> {
    !environment.production && console.log('[LineAssociation] Eliminando línea:', request);

    return this.http.put<ApiResponse<void>>(`${this.CUSTOMER_ENDPOINT}/line/detach`, request);
  }

  /**
   * Valida si una línea es Virgin Mobile y está activa
   * Endpoint: POST /profile/light-profile
   */
  validateMsisdn(msisdn: string): Observable<
    ApiResponse<{
      responseCode: string;
      state: string;
    }>
  > {
    !environment.production && console.log('[LineAssociation] Validando MSISDN:', msisdn);

    return this.http.post<ApiResponse<{ responseCode: string; state: string }>>(
      `${this.PROFILE_ENDPOINT}/light-profile`,
      { msisdn }
    );
  }
}
